import React, { useState } from "react";
import axios from "axios";
import { Button, Row, Col, Spinner } from "react-bootstrap";
import "./AutoSuggest.css";
import { FaCity } from "react-icons/fa";
import { Link } from "react-router-dom";

const AutoSuggest = ({
  initGeolocation,
  closeCityInput,
  handleCitySelect,
  cities2,
  setCities2,
  handleCitySearch,
  loading,
}) => {
  const topCities = [
    {
      id: 130443,
      CityName: "New Delhi",
      CountryName: "India",
      CountryCode: "IN",
      isTopCity: true,
      category: "domestic",
    },
    {
      id: 144306,
      CityName: "Mumbai",
      CountryName: "India",
      CountryCode: "IN",
      isTopCity: true,
      category: "domestic",
    },
    {
      id: 111124,
      CityName: "Bangalore",
      CountryName: "India",
      CountryCode: "IN",
      isTopCity: true,
      category: "domestic",
    },
    {
      id: 133133,
      CityName: "Pune",
      CountryName: "India",
      CountryCode: "IN",
      isTopCity: true,
      category: "domestic",
    },
    {
      id: 100263,
      CityName: "Ahmedabad",
      CountryName: "India",
      CountryCode: "IN",
      isTopCity: true,
      category: "domestic",
    },
    {
      id: 122175,
      CityName: "Jaipur",
      CountryName: "India",
      CountryCode: "IN",
      isTopCity: true,
      category: "domestic",
    },
    {
      id: 100589,
      CityName: "Agra",
      CountryName: "India",
      CountryCode: "IN",
      isTopCity: true,
      category: "domestic",
    },
    {
      id: 145710,
      CityName: "Hyderabad",
      CountryName: "India",
      CountryCode: "IN",
      isTopCity: true,
      category: "domestic",
    },
    {
      id: 115936,
      CityName: "Dubai",
      CountryName: "United Arab Emirates",
      CountryCode: "AE",
      isTopCity: true,
      category: "international",
    },
    {
      id: 100765,
      CityName: "Abu Dhabi",
      CountryName: "United Arab Emirates",
      CountryCode: "AE",
      isTopCity: true,
      category: "international",
    },
    {
      id: 138703,
      CityName: "Singapore",
      CountryName: "Singapore",
      CountryCode: "SG",
      isTopCity: true,
      category: "international",
    },
    {
      id: 144092,
      CityName: "Bangkok",
      CountryName: "Thailand",
      CountryCode: "TH",
      isTopCity: true,
      category: "international",
    },
  ];
  const [inputValue, setInputValue] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [internalLoading, setInternalLoading] = useState(false);
  const [error, setError] = useState(null);

  // useEffect(() => {
  //   if (inputValue) {
  //     fetchDatas(inputValue);
  //   } else {
  //     setSuggestions([]);
  //   }
  // }, [inputValue]);

  // const fetchDatas = async (value) => {
  //   setLoading(true);
  //   try {
  //     const response = await fetch(
  //       "https://admin.Innovate Blues.com/api/Hotel/CityList"
  //     );
  //     if (!response.ok) throw new Error("Failed to fetch data");
  //     const json = await response.json();
  //     const results = json.data.response.cil
  //       .filter((user) => {
  //         return (
  //           user &&
  //           ((user.cityName &&
  //             user.cityName.toLowerCase().includes(value.toLowerCase())) ||
  //             (user.countryName &&
  //               user.countryName.toLowerCase().includes(value.toLowerCase())) ||
  //             (user.fullRegionName &&
  //               user.fullRegionName
  //                 .toLowerCase()
  //                 .includes(value.toLowerCase())))
  //         );
  //       })
  //       .map((user) => {
  //         let priority = 3;
  //         if (
  //           user.cityName &&
  //           user.cityName.toLowerCase().includes(value.toLowerCase())
  //         ) {
  //           priority = 1;
  //         } else if (
  //           user.countryName &&
  //           user.countryName.toLowerCase().includes(value.toLowerCase())
  //         ) {
  //           priority = 2;
  //         }
  //         return { ...user, priority };
  //       })
  //       .sort((a, b) => a.priority - b.priority);

  //     setSuggestions(results);
  //   } catch (error) {
  //     setError(error.message);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const fetchDatas = async (value) => {
    // setLoading(true);
    setError(null);
    try {
      const requestData = {
        city: value,
      };

      const response = await axios.post(
        "https://admin.Innovate Blues.com/api/Hotel/CityList",
        requestData
      );

      // If API returns JSON directly in response.data
      const json = response.data;
      console.log("json responseee", json);

      const results = json.data
        .filter((user) => {
          return (
            user &&
            ((user.CityName &&
              user.CityName.toLowerCase().includes(value.toLowerCase())) ||
              (user.CountryName &&
                user.CountryName.toLowerCase().includes(value.toLowerCase())))
          );
        })
        .map((user) => {
          let priority = 3;

          if (
            user.CityName &&
            user.CityName.toLowerCase().includes(value.toLowerCase())
          ) {
            priority = 1;
          } else if (
            user.CountryName &&
            user.CountryName.toLowerCase().includes(value.toLowerCase())
          ) {
            priority = 2;
          }

          return { ...user, priority };
        })
        .sort((a, b) => a.priority - b.priority);

      setCities2(results);
    } catch (error) {
      console.error("Error fetching data:", error);
      setError("Unable to fetch cities. Please try again.");
    } finally {
      // setLoading(false);
    }
  };

  // Initialize with topCities and switch to API results when typing

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value); // Update local state for the input

    // Always call the parent's search function which handles all cases
    handleCitySearch(value);
  };

  // const handleInputChange = (event) => {
  //   setInputValue(event.target.value);
  //   setSuggestions([
  //     "Delwaraaaaaaa, Udaipur, Rajasthan, India",
  //     "Delwara, Udaipur, Rajasthan, India",
  //   ]);
  // };

  // const handleClearInput = () => {
  //   setInputValue("");
  //   setSuggestions([]);
  // };

  const handleback = () => {
    setInputValue("");
    closeCityInput();
  };

  const handleAddAutoCity = (city) => {
    setInputValue(city.cityName || city);
    closeCityInput();
    setSuggestions([]);
    handleCitySelect(city); // Pass the selected city back to the parent component
  };

  return (
    <div className="rcnt-src-at" id="autosgt">
      <div className="autosugst_newblock" id="stickyheaderCal">
        <div className="fli-c-blv2">
          <div className="fli-m-bl">
            <div>
              <Link className="back_btn" onClick={handleback}>
                <img
                  src="https://www.easemytrip.com/images/auto-sugg-icon/arrow-back.png"
                  alt="Back"
                />
              </Link>
              <input
                type="text"
                className="input_New_auto"
                id="txtsearch"
                name="txtfrom"
                required
                placeholder="Enter City/Location/Hotel Name"
                autoComplete="off"
                value={inputValue}
                onChange={handleInputChange}
              />
              {/* {inputValue && (
                <a className="sugg_cross" onClick={handleClearInput}>
                  <img
                    src="https://www.easemytrip.com/images/auto-sugg-icon/sugg-cross.png"
                    alt="Clear"
                  />
                </a>
              )} */}
            <div className="auto_sugg mgt100">
              {error ? (
                <div
                  style={{
                    padding: "10px 5px",
                    fontSize: "12px",
                    textAlign: "center",
                    margin: "auto",
                    width: "100%",
                    backgroundColor: "white",
                  }}
                >
                  {error}
                </div>
              ) : (
                <>
                  {cities2.length > 0 && cities2.filter((c) => !c.isTopCity).length === 0 ? (
                    <div className="desktop_autosugg">
                      <div className="desk_sugg_bx flx-clm marbtm0">
                        <div className="rec_txt">Popular Search in Domestic</div>
                        <div className="clr" />
                        <div className="pop_city_bx">
                          {topCities
                            .filter((city) => city.category === "domestic")
                            .map((city, index) => (
                              <Button variant="link" key={index} onClick={() => handleCitySelect(city)}>
                                {city.CityName}
                              </Button>
                            ))}
                        </div>

                        <div className="rec_txt">Popular Search in International</div>
                        <div className="clr" />
                        <div className="pop_city_bx">
                          {topCities
                            .filter((city) => city.category === "international")
                            .map((city, index) => (
                              <Button variant="link" key={index} onClick={() => handleCitySelect(city)}>
                                {city.CityName}
                              </Button>
                            ))}
                        </div>
                      </div>
                    </div>
                  ) : (
                    <>
                      {cities2.map((city, index) => (
                        <div
                          key={index}
                          style={{ borderBottom: "1px solid grey", paddingBottom: 5, marginBottom: 5, cursor: "pointer" }}
                          onClick={() => handleCitySelect(city)}
                        >
                          <div style={{ display: "flex", gap: "5px", width: "100%" }}>
                            <div>
                              <div className="flightFromName" style={{ color: "#2d3290", fontWeight: 600 }}>
                                <FaCity size={22} style={{ textAlign: "center", height: "100%", color: "#2d3290", marginRight: "10px" }} />
                                {city.CityName}
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}

                      {loading && (
                        <div style={{ padding: "8px 5px", fontSize: "12px", textAlign: "center" }}>
                          <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> {" "}
                          Loading more results...
                        </div>
                      )}
                    </>
                  )}

                  {cities2.length === 0 && (
                    <div
                      style={{
                        padding: "10px 5px",
                        fontSize: "12px",
                        textAlign: "center",
                        margin: "auto",
                        width: "100%",
                        backgroundColor: "white",
                      }}
                    >
                      {loading ? (
                        <>
                          <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> {" "}
                          Fetching city list...
                        </>
                      ) : (
                        <>No matching cities found</>
                      )}
                    </div>
                  )}
                </>
              )}
            </div>

            </div>
          </div>
        </div>

        <div className="clr" />

        {inputValue && suggestions.length > 0 && (
          <div className="auto_sugg mgt100">
            <ul id="divAppend" className="rcnt-bx-at">
              {suggestions.map((city, index) => (
                <li
                  key={index}
                  className="auto_sugg_list rcnt-bx2-at"
                  id={`msl${index}|city`}
                  onClick={() => handleAddAutoCity(city)}
                >
                  {/* <div className="w_10">
                    <div className="auto_sugg_img">
                      <Image src="https://www.easemytrip.com/images/auto-sugg-icon/city.png" />
                    </div>
                    <div className="auto_sugg_add">city</div>
                  </div> */}
                  <div className="w_85">
                    <div
                      className="auto_sugg_tttl"
                      id={`autohotelmsl${index}city`}
                    >
                      {/* {city.cityName},  */}
                      {city.fullRegionName}
                      {/* , {city.countryName} */}
                    </div>
                  </div>
                </li>
                // <li className="auto_sugg_list rcnt-bx2-at" id="msl240673|city">
                //   <div className="w_10">
                //     <div className="auto_sugg_img">
                //       <Image src="https://www.easemytrip.com/images/auto-sugg-icon/city.png" />
                //     </div>
                //     <div className="auto_sugg_add">city</div>
                //   </div>
                //   <div className="w_85">
                //     <div className="auto_sugg_tttl" id="autohotelmsl240673city">
                //       Delwara, Udaipur, Rajasthan, India
                //     </div>
                //   </div>
                // </li>
                // <li className="auto_sugg_list rcnt-bx2-at" id="msl240673|city">
                //   <div className="w_10">
                //     <div className="auto_sugg_img">
                //       <Image src="https://www.easemytrip.com/images/auto-sugg-icon/city.png" />
                //     </div>
                //     <div className="auto_sugg_add">city</div>
                //   </div>
                //   <div className="w_85">
                //     <div className="auto_sugg_tttl" id="autohotelmsl240673city">
                //       Delwara, Udaipur, Rajasthan, India
                //     </div>
                //   </div>
                // </li>
              ))}
            </ul>
          </div>
        )}

        <div className="rcnt-bx1-at new_old pd20_main " id="home">
          <div
            className="rcnt-bx2-at spc-cty-at newGpsLoc"
            style={{ display: "none" }}
          >
            <div
              className="DivGpsec"
              onClick={initGeolocation}
              style={{ display: "none" }}
            >
              <div className="imgGpsec">
                <img
                  src="https://www.easemytrip.com/images/mob-web/hotel-img/newGpsLoc-blue.svg"
                  alt="GPS"
                />
              </div>
              <div className="Gpstxt">
                <h4>Current Location</h4>
                <p>Using GPS</p>
              </div>
            </div>
            <div className="clr" />
          </div>
          <div className="m_sugg_bx flx-clm">
            <div className="rec_txt">Popular Search in Domestic</div>
            <div className="clr" />
            <div className="pop_city_bx">
              {topCities
                .filter((city) => city.category === "domestic")
                .map((city, index) => (
                  <Button
                    variant="link"
                    key={index}
                    onClick={() => handleCitySelect(city)}
                  >
                    {city.CityName}
                  </Button>
                ))}
            </div>
            <div className="clr" />
            <div className="bdr_lg_sugg" />
            <div className="clr" />
            <div className="rec_txt">Popular Search in International</div>
            <div className="clr" />
            <div className="pop_city_bx">
              {topCities
                .filter((city) => city.category === "international")
                .map((city, index) => (
                  <Button
                    variant="link"
                    key={index}
                    onClick={() => handleCitySelect(city)}
                  >
                    {city.CityName}
                  </Button>
                ))}
            </div>
          </div>
        </div>
        <div className="clr" />
      </div>
    </div>
  );
};

export default AutoSuggest;
